export default {
    //=============================================UserInfo
    SET_USERINFO(state, payload) {
        console.log("FUCK", payload)
        state.userInfo = payload;
        state.userInfo.isAuthenticated = true;
        if (window.localStorage) {
            localStorage.setItem("userInfo", JSON.stringify(payload));
        }
    },
    SET_ISAUTHENTICATED(state, payload) {
        state.userInfo.isAuthenticated = payload;
        localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
    },
    SET_USER_ACCESSES(state, payload) {
        state.userAccesses = payload;
    },
    //=============================================UserInfo
    //=============================================Dashboard
    SET_DASHBOARDINFO(state, payload) {
        state.dashboard = payload;
    },
    //=============================================Dashboard
    //=============================================SnackBar
    SET_SNACKBAR(state, payload) {
        state.snackBar = payload;
    },
    //=============================================Devices
    SET_DEVICES(state, payload) {
        state.devices = payload;
    },
    SET_DEVICESTATUS(state, payload) {
        state.deviceStatus = payload;
    },
    SET_DEVICE_STATE(state, payload) {
        state.keyStatus = payload;
        console.log("Payload", payload)
    },
    SET_THERMOSTATE(state, payload) {
        state.thermostate = payload;
    },
    SET_THERMOSTATE_RESPONSE(state, payload) {
        state.thermostateResponse = payload;
    },
    //=============================================Devices
    //=============================================Groups
    SET_GROUPS(state, payload) {
        state.groups = payload;
    },
    SET_GROUPINFO(state, payload) {
        state.groupinfo = payload;
    },
    //=============================================Groups
    //=============================================Users
    SET_DEVICESTATUS(state, payload) {
        state.deviceStatus = payload;
    },
    //=============================================Users
    //=============================================Ping
    SET_LOGINFO(state, payload) {
        state.pingInfo = payload;
    }
    //=============================================Ping


}